import { render, staticRenderFns } from "./ViewRegister.vue?vue&type=template&id=3f20bfff&scoped=true"
import script from "./ViewRegister.vue?vue&type=script&lang=js"
export * from "./ViewRegister.vue?vue&type=script&lang=js"
import style0 from "./ViewRegister.vue?vue&type=style&index=0&id=3f20bfff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20bfff",
  null
  
)

export default component.exports